import React, { Component } from 'react'
import { SlideInUp, FadeIn } from 'animate-css-styled-components'
import styled from 'styled-components'
import Logic from './logic'

import TariffSubscribeModal from 'containers/TariffSubscribeModal'
import ResultItem from 'components/ResultItem'
import Modal from 'components/ModalExtended'
import TariffDetails from 'components/TariffDetails'
import Loading from 'components/Loading'
import { sendGevent } from 'utils'

@Logic
export default class Results extends Component {
  state = {
    moreOpen: false,
    adhesionOpen: false,
    adhesionTariff: null,
    priceListTimeCycle: null
  }

  /** Detail modal buttons */
  detailsButtons = [
    {
      label: 'fechar',
      color: '#006736',
      primary: false,
      click: () => this.toggleMoreModal(null)
    },
    {
      label: 'aderir',
      primary: true,
      click: () => this.switchToAdhere()
    }
  ]

  switchToAdhere = () => {
    this.setState({
      moreOpen: false,
      detailsTariff: null,
      adhesionOpen: true
    })
  }

  /**
   * Opens/Closes KnowMore modal
   */
  toggleMoreModal = (tariff) => {
    sendGevent('simulador', 'Saber mais', 'Saber mais sobre um tarifário')
    tariff && this.actions.fetchTariffInfo(tariff.id)
    const tariffPriceListTimeCycle = tariff && tariff.priceListTimeCycle
    this.setState({ moreOpen: !this.state.moreOpen, detailsTariff: tariff, adhesionTariff: tariff, priceListTimeCycle: tariffPriceListTimeCycle || null })
  }

  /**
   * Opens/Closes aderir modal
   */
  toggleAdhereModal = (tariff) => {
    sendGevent('simulador', 'Aderir', 'Aderir a um tarifário')

    this.setState({ adhesionTariff: tariff, adhesionOpen: !this.state.adhesionOpen })
  }

  render () {
    const {
      results,
      filters,
      bestAnnualBilling,
      loading,
      simulation,
      tariffInfo,
      userProfile
    } = this.props

    return (
      <Wrapper>
        {/* List of results */}
        {
          results &&
            results.map((item, index) =>
              <FadeIn duration={`0.4s`} key={`result-${item.id}-${index}`} id={`result-${index}`}>
                <SlideInUp duration={`0.4s`} delay={`${index * 0.08}s`}>
                  <ResultItem
                    {...item}
                    bestAnnualBilling={bestAnnualBilling}
                    clickMore={this.toggleMoreModal}
                    clickAdhere={this.toggleAdhereModal}
                    filters={filters}
                />
                </SlideInUp>
              </FadeIn>
            )
        }

        {/* Know More Modal */}
        {this.state.detailsTariff && this.state.moreOpen &&
          <Modal
            title='detalhes do tarifário'
            toggle={this.state.moreOpen}
            onClick={this.toggleMoreModal}
            custom={false}
            buttons={this.detailsButtons}
          >
            {!loading && 
              <TariffDetails 
                tariff={tariffInfo}
                resultTariff={this.state.detailsTariff}
                priceListTimeCycle={this.state.priceListTimeCycle}
                />}
            {loading && <Loading />}
            </Modal>
          }
          
          {/* Aderir Modal */}
          {this.state.adhesionTariff && this.state.adhesionOpen &&
            <TariffSubscribeModal
            userProfile={userProfile}
            tariff={this.state.adhesionTariff}
            changeTariff={this.toggleAdhereModal}
            simulation={simulation}
            />
        }
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  min-height: 500px;
  width: 100%;
  position: relative;
  padding: 20px 0;
  top: -70px;

  @media(max-width: 1280px) {
    top: 0;
  }
`



// WEBPACK FOOTER //
// ./src/containers/ResultsList/index.js